import { post } from "@/api/public.client";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { useEffect } from "react";

const firebaseConfig = {
  apiKey: "AIzaSyBVaVROtCLzPBs8FYFpN6NZ_7tknuhFfYE",
  authDomain: "sacred-store-393509.firebaseapp.com",
  projectId: "sacred-store-393509",
  storageBucket: "sacred-store-393509.appspot.com",
  messagingSenderId: "990696700415",
  appId: "1:990696700415:web:b305646e556e3501bc0fca",
};

const getFirebaseToken = async (): Promise<string> => {
  if (
    typeof window != "undefined" &&
    "serviceWorker" in navigator &&
    Notification.permission == "granted"
  ) {
    try {
      const app = initializeApp(firebaseConfig);
      const messaging = getMessaging(app);
      const token = await getToken(messaging, {
        vapidKey:
          "BDtssl5nNrOfrTgDjxQm3B_CLerDj8KOauudCJhRc4DNacosvZJqB-vL2CuWwbaK_YZatGhqqwpsUDlUv3GhQG4",
      });
      return token;
    } catch (error) {
      console.error("Error getting Firebase token:", error);
      return "";
    }
  }
  return "";
};

export const subscribeTokenToTopic = async (
  token: string | null,
  topics: string[],
) => {
  try {
    return post("/notifications/subscribe", {
      body: {
        fcmToken: token ?? (await getFirebaseToken()),
        topics: topics,
      },
    });
  } catch (error) {
    console.error("Error sending token to backend:", error);
  }
};

export const unsubscribeTokenFromTopic = async (
  token: string | null,
  topics: string[],
) => {
  try {
    return post("/notifications/unsubscribe", {
      body: {
        fcmToken: token ?? (await getFirebaseToken()),
        topics: topics,
      },
    });
  } catch (error) {
    console.error("Error sending token to backend:", error);
  }
};

const registerServiceWorker = async (): Promise<void> => {
  try {
    await navigator.serviceWorker.register("/firebase-messaging-sw.js");
  } catch (error) {
    console.error("Error registering service worker:", error);
  }
};

const useNotificationListener = () => {
  const app = initializeApp(firebaseConfig);
  const messaging = getMessaging(app);
  return new Promise((resolve) => {
    messaging &&
      onMessage(messaging, (payload) => {
        resolve(payload);
      });
  });
};

export const NotificationHandler = () => {
  useNotificationListener().then((value) => {
    // console.log("hello world ", value);
    alert(value);
  });
};

const useFirebaseNotifications = (topics: any): void => {
  useEffect(() => {
    (async () => {
      if (topics && "serviceWorker" in navigator) {
        try {
          const token = await getFirebaseToken();
          if (token) {
            const enabledTopics = localStorage.getItem(
              "enabled-notification-topics",
            );

            const disabledTopics = localStorage.getItem(
              "disabled-notification-topics",
            );

            // Check if topics are already in local storage for both enabled and disabled lists
            const existingEnabledTopics = enabledTopics
              ? JSON.parse(enabledTopics)
              : [];
            const existingDisabledTopics = disabledTopics
              ? JSON.parse(disabledTopics)
              : [];

            // Filter out topics that are already in either enabled or disabled lists
            const newTopics = topics.filter(
              (topic: string) =>
                !existingEnabledTopics.includes(topic) &&
                !existingDisabledTopics.includes(topic),
            );

            const response = await subscribeTokenToTopic(token, newTopics);
            if (!response?.error) {
              // Add new topics to the enabled list in local storage without duplicates
              let updatedEnabledTopics: string[] = existingEnabledTopics;
              updatedEnabledTopics = [
                ...new Set([...updatedEnabledTopics, ...newTopics]),
              ];
              localStorage.setItem(
                "enabled-notification-topics",
                JSON.stringify(updatedEnabledTopics),
              );
            }
          }
          registerServiceWorker();
        } catch (error) {
          console.error("Error handling Firebase token:", error);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default function FirebaseWrapper({ topics }: any) {
  useFirebaseNotifications(topics);
  return <></>;
}
